import { GVSnackMessage } from '../components/lib/GVSnackbar/GVSnackbar';
import { UserPreferences, SavedGraphicMode, DisplaySettings } from './myAccount';
import { Integration } from './integrations';
import { CTFModuleTypes, DocumentTypes } from './inspection';

export type GraphicMode = 'flashing' | 'transparentOverlay' | '';

export interface CloningOperation {
  id: string;
  inspectionId: string;
  inspectionName?: string;
  startTime: Date;
}

export interface AppState {
  loginAttempts: string[];
  snackMessage: GVSnackMessage;
  snackMessageQueue: Array<GVSnackMessage>;
  fetchingDifferences: boolean;
  autosaving: boolean;
  updatingInspection: boolean;
  startingInspection: boolean;
  resetIdleTimer: boolean;
  popUpNotifications: Array<{ type: string; dismissed: boolean }>;
  userPreferences: UserPreferences;
  /** Cog settings stored for this user. Missing fields fall back when the viewer restores them. */
  savedDisplaySettings: Partial<DisplaySettings>;
  toastStatuses: ToastStatuses;
  integrations: Integration[];
  displayName: string;
  showLiveText: boolean;
  showTextHighlights: boolean;
  focusedMatchIndex: number;
  showDifferenceBoxes: boolean;
  hideOtherDifferences: boolean;
  showOverlay: boolean;
  grayscaleMode: boolean;
  singlePageView: boolean;
  showRepeats: boolean;
  graphicMode: GraphicMode;
  lastGraphicMode: SavedGraphicMode;
  transparencyOpacity: number;
  cloningOperations: CloningOperation[];
  isCloningModalOpen: boolean;
  closeConfirm: boolean;
  isReopenedSession: boolean;
  unavailableFiles: string[];
  selectedModule: CTFModuleTypes | 'All';
  hideDisplayPanels: { [key in DocumentTypes]: boolean };
  showMarkupTab: boolean;
}

export enum LeftPanelTabIndexes {
  prep = 0,
  result = 1,
}

export interface ToastStatuses {
  hasPanToolToastShown: boolean;
}
